import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/ContentElements/HexagonList/Hexagon/Hexagon.css';

export const prototypeName = 'GLOdwKxn2bC59enGPlogIVGrr4WX9kSZKoAoZx6jC62dQoyoR4h9X2XrWn4XUwDvZQdr7ziVWv2W62Lof3VPeKbQpoH9d';
export {styles};